import React from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../images/logo.png";
import logoText from "../../../images/logo-text.png";
import {useDispatch, useSelector} from "react-redux";
import {isTerminal} from "../../common/utils";
import {setActiveRestaurantCategoryAction} from "../../../store/actions/RestaurantActions";

const NavHader = () => {
  const dispatch = useDispatch();
  const storeAuth = useSelector(store => store.auth);
  const store = useSelector(store => store.restaurants);
  const userData = storeAuth.auth.userData;

  function landingLocation() {
    const restaurant = Object.values(store.restaurants)[0];
    if (!!restaurant) {
      return [restaurant.latitude, restaurant.longitude]
    }
    return [];
  }

  const handleSidebarToggle = () => {
    const mainWrapper = document.querySelector("#main-wrapper");
    const sidebarClose = document.querySelector("#sidebar-close");
    if (mainWrapper) {
      mainWrapper.classList.add("menu-toggle");
    }
    if (sidebarClose) {
      sidebarClose.classList.add('sidebar-close');
    }
  };

  return (
    <div className="nav-header" style={{background: 'none'}}>
      { isTerminal() ?
        <div className='brand-logo terminal-brand-link' style={{cursor: 'pointer'}}
             onClick={() => dispatch(setActiveRestaurantCategoryAction(''))}
        >
          <img className="logo-abbr" src={logo} alt=""  />
          <img className="logo-compact" src={logoText} alt="" />
          <img className='brand-title terminal-brand' src={logoText} alt=""/>
        </div>
      :
        <Link to={{ pathname: '/', landing_location: landingLocation() }} className={`brand-logo`}
          style={{marginLeft: (!!userData && (!storeAuth.auth.idToken || userData.role === 'default')) ? 0 : 20}}
        >
          <img className="logo-abbr" src={logo} alt="" />
          <img className="logo-compact" src={logoText} alt="" />
          <img className='brand-title' src={logoText} alt="" />
        </Link>}
      { !isTerminal() &&
        <div className={`nav-control ${(!!userData && (!storeAuth.auth.idToken || userData.role === 'default')) && 'd-none'}`}
             onClick={handleSidebarToggle}>
          <div className='hamburger'><span className="line"/><span className="line"/><span className="line"/></div>
        </div>}
    </div>
   );
};
export default NavHader;